import { Component, ChangeDetectionStrategy } from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
	selector: 'app-privacy',
	imports: [
		TranslatePipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './privacy.component.html',
})
export class PrivacyComponent {

}
